import BaseApi from '@/api/Base/BaseApi'

import {
  ModelPipelineInstanceNodeInfo,
  ModelPipelineInstanceNodeItemListResponse,
  UpdateModelPipelineInstanceNodePayload
} from '@/api/ModelPipelineInstanceNode/types'
import { ModelValueType } from '@/pages/const'
import { ModelNodeInfo } from '@/api/ModelNode/types'
import { CommonListPayload } from '@/api/Node/types'

// FIXME: root
const ROOT = '/model-instance'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'desc',
  sortKey: 'createdAt',
}

export default class ModelPipelineInstanceNodeApi extends BaseApi {
  getAvailableModels(projectId: string, modelType: ModelValueType) {
    return this.agent.get<ModelNodeInfo[]>(`${ROOT}/${projectId}/available-models`, {
      params: { modelType },
    })
  }

  getModelPipelineInstanceNode(modelPipelineInstanceNodeId: string) {
    return this.agent.get<ModelPipelineInstanceNodeInfo>(`${ROOT}/${modelPipelineInstanceNodeId}`)
  }

  updateModelPipelineInstanceNode(payload: UpdateModelPipelineInstanceNodePayload) {
    const { modelPipelineInstanceNodeId, ...rest } = payload
    return this.agent.put<ModelPipelineInstanceNodeInfo>(`${ROOT}/${modelPipelineInstanceNodeId}`, rest)
  }

  runInference(modelPipelineInstanceNodeId: string) {
    return this.agent.post(`${ROOT}/${modelPipelineInstanceNodeId}/inference`)
  }

  getResultItems(modelPipelineInstanceNodeId: string, options?: CommonListPayload) {
    const { itemsPerPage, page, sortDir, sortKey } = options ?? defaultPaginationOptions
    return this.agent.get<ModelPipelineInstanceNodeItemListResponse>(`${ROOT}/${modelPipelineInstanceNodeId}/items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }

  getModelPipelineInstanceResult(modelPipelineInstanceNodeId: string) {
    return this.agent.get(`${ROOT}/${modelPipelineInstanceNodeId}/inference-result`)
  }
}
